export enum Country {
  US = 'US',
}

export const REFINITIV_COUNTRIES = [
  { name: 'Albania', iso2: 'AL' },
  { name: 'Algeria', iso2: 'DZ' },
  { name: 'Andorra', iso2: 'AD' },
  { name: 'Anguilla', iso2: 'AI' },
  { name: 'Antigua', iso2: 'AG' },
  { name: 'Argentina', iso2: 'AR' },
  { name: 'Armenia', iso2: 'AM' },
  { name: 'Aruba', iso2: 'AW' },
  { name: 'Australia', iso2: 'AU' },
  { name: 'Austria', iso2: 'AT' },
  { name: 'Azerbaijan', iso2: 'AZ' },
  { name: 'Bahamas', iso2: 'BS' },
  { name: 'Bahrain', iso2: 'BH' },
  { name: 'Bangladesh', iso2: 'BD' },
  { name: 'Barbados', iso2: 'BB' },
  { name: 'Belarus', iso2: 'BY' },
  { name: 'Belgium', iso2: 'BE' },
  { name: 'Belize', iso2: 'BZ' },
  { name: 'Benin', iso2: 'BJ' },
  { name: 'Bermuda', iso2: 'BM' },
  { name: 'Bhutan', iso2: 'BT' },
  { name: 'Bolivia', iso2: 'BO' },
  { name: 'Bosnia and Herzegovina', iso2: 'BA' },
  { name: 'Botswana', iso2: 'BW' },
  { name: 'Brazil', iso2: 'BR' },
  { name: 'British Virgin Islands', iso2: 'VG' },
  { name: 'Brunei', iso2: 'BN' },
  { name: 'Bulgaria', iso2: 'BG' },
  { name: 'Burkina Faso', iso2: 'BF' },
  { name: 'Burundi', iso2: 'BI' },
  { name: 'Cambodia', iso2: 'KH' },
  { name: 'Cameroon', iso2: 'CM' },
  { name: 'Canada', iso2: 'CA' },
  { name: 'Cayman Islands', iso2: 'KY' },
  { name: 'Channel Islands', iso2: 'JE' },
  { name: 'Chile', iso2: 'CL' },
  { name: 'China', iso2: 'CN' },
  { name: 'Colombia', iso2: 'CO' },
  { name: 'Comoros', iso2: 'KM' },
  { name: 'Congo', iso2: 'CG' },
  { name: 'Congo DRC', iso2: 'CD' },
  { name: 'Cook Islands', iso2: 'CK' },
  { name: 'Costa Rica', iso2: 'CR' },
  { name: "Côte d'Ivoire", iso2: 'CI' },
  { name: 'Croatia', iso2: 'HR' },
  { name: 'Cuba', iso2: 'CU' },
  { name: 'Curaçao', iso2: 'CW' },
  { name: 'Cyprus', iso2: 'CY' },
  { name: 'Czech Republic', iso2: 'CZ' },
  { name: 'Denmark', iso2: 'DK' },
  { name: 'Dominican Republic', iso2: 'DO' },
  { name: 'Ecuador', iso2: 'EC' },
  { name: 'Egypt', iso2: 'EG' },
  { name: 'El Salvador', iso2: 'SV' },
  { name: 'Estonia', iso2: 'EE' },
  { name: 'Eswatini', iso2: 'SZ' },
  { name: 'Ethiopia', iso2: 'ET' },
  { name: 'Faroe Islands', iso2: 'FO' },
  { name: 'Fiji', iso2: 'FJ' },
  { name: 'Finland', iso2: 'FI' },
  { name: 'France', iso2: 'FR' },
  { name: 'French Guiana', iso2: 'FG' },
  { name: 'French Pacific', iso2: 'PF' },
  { name: 'Gabon', iso2: 'GA' },
  { name: 'Gambia', iso2: 'GM' },
  { name: 'Georgia', iso2: 'GE' },
  { name: 'Germany', iso2: 'DE' },
  { name: 'Ghana', iso2: 'GH' },
  { name: 'Gibraltar', iso2: 'GI' },
  { name: 'Greece', iso2: 'GR' },
  { name: 'Greenland', iso2: 'GL' },
  { name: 'Grenada', iso2: 'GD' },
  { name: 'Guadeloupe', iso2: 'GP' },
  { name: 'Guam', iso2: 'GU' },
  { name: 'Guatemala', iso2: 'GT' },
  { name: 'Guernsey', iso2: 'GG' },
  { name: 'Guinea', iso2: 'GN' },
  { name: 'Guinea-Bissau', iso2: 'GW' },
  { name: 'Guyana', iso2: 'GY' },
  { name: 'Haiti', iso2: 'HT' },
  { name: 'Honduras', iso2: 'HN' },
  { name: 'Hong Kong', iso2: 'HK' },
  { name: 'Hungary', iso2: 'HU' },
  { name: 'Iceland', iso2: 'IS' },
  { name: 'India', iso2: 'IN' },
  { name: 'Indonesia', iso2: 'ID' },
  { name: 'Iran', iso2: 'IR' },
  { name: 'Iraq', iso2: 'IQ' },
  { name: 'Ireland', iso2: 'IE' },
  { name: 'Isle of Man', iso2: 'IM' },
  { name: 'Israel', iso2: 'IL' },
  { name: 'Italy', iso2: 'IT' },
  { name: 'Jamaica', iso2: 'JM' },
  { name: 'Japan', iso2: 'JP' },
  { name: 'Jordan', iso2: 'JO' },
  { name: 'Kazakhstan', iso2: 'KZ' },
  { name: 'Kenya', iso2: 'KE' },
  { name: 'Kuwait', iso2: 'KW' },
  { name: 'Kyrgyzstan', iso2: 'KG' },
  { name: 'Laos', iso2: 'LA' },
  { name: 'Latvia', iso2: 'LV' },
  { name: 'Lebanon', iso2: 'LB' },
  { name: 'Lesotho', iso2: 'LS' },
  { name: 'Liechtenstein', iso2: 'LI' },
  { name: 'Lithuania', iso2: 'LT' },
  { name: 'Luxembourg', iso2: 'LU' },
  { name: 'Macao', iso2: 'MO' },
  { name: 'Madagascar', iso2: 'MG' },
  { name: 'Malawi', iso2: 'MW' },
  { name: 'Malaysia', iso2: 'MY' },
  { name: 'Maldives', iso2: 'MV' },
  { name: 'Mali', iso2: 'ML' },
  { name: 'Malta', iso2: 'MT' },
  { name: 'Marshall Islands', iso2: 'MH' },
  { name: 'Martinique', iso2: 'MQ' },
  { name: 'Mauritania', iso2: 'MR' },
  { name: 'Mauritius', iso2: 'MU' },
  { name: 'Mexico', iso2: 'MX' },
  { name: 'Moldova', iso2: 'MD' },
  { name: 'Monaco', iso2: 'MC' },
  { name: 'Mongolia', iso2: 'MN' },
  { name: 'Montenegro', iso2: 'ME' },
  { name: 'Morocco', iso2: 'MA' },
  { name: 'Mozambique', iso2: 'MZ' },
  { name: 'Myanmar', iso2: 'MM' },
  { name: 'Namibia', iso2: 'NA' },
  { name: 'Nepal', iso2: 'NP' },
  { name: 'Netherlands Antilles', iso2: 'AN' },
  { name: 'Netherlands', iso2: 'NL' },
  { name: 'New Zealand', iso2: 'NZ' },
  { name: 'Nicaragua', iso2: 'NI' },
  { name: 'Niger', iso2: 'NE' },
  { name: 'Nigeria', iso2: 'NG' },
  { name: 'North Macedonia', iso2: 'MK' },
  { name: 'Norway', iso2: 'NO' },
  { name: 'Oman', iso2: 'OM' },
  { name: 'Pakistan', iso2: 'PK' },
  { name: 'Palestine', iso2: 'PS' },
  { name: 'Panama', iso2: 'PA' },
  { name: 'Papua New Guinea', iso2: 'PG' },
  { name: 'Paraguay', iso2: 'PY' },
  { name: 'Peru', iso2: 'PE' },
  { name: 'Philippines', iso2: 'PH' },
  { name: 'Poland', iso2: 'PL' },
  { name: 'Portugal', iso2: 'PT' },
  { name: 'Puerto Rico', iso2: 'PR' },
  { name: 'Qatar', iso2: 'QA' },
  { name: 'Republic of Angola', iso2: 'AO' },
  { name: 'Réunion', iso2: 'RE' },
  { name: 'Romania', iso2: 'RO' },
  { name: 'Russian Federation', iso2: 'RU' },
  { name: 'Rwanda', iso2: 'RW' },
  { name: 'Saint Kitts and Nevis', iso2: 'KN' },
  { name: 'Samoa', iso2: 'WS' },
  { name: 'Saudi Arabia', iso2: 'SA' },
  { name: 'Senegal', iso2: 'SN' },
  { name: 'Serbia', iso2: 'RS' },
  { name: 'Seychelles', iso2: 'SC' },
  { name: 'Sierra Leone', iso2: 'SL' },
  { name: 'Singapore', iso2: 'SG' },
  { name: 'Sint Maarten', iso2: 'SX' },
  { name: 'Slovakia', iso2: 'SK' },
  { name: 'Slovenia', iso2: 'SI' },
  { name: 'Solomon Islands', iso2: 'SB' },
  { name: 'South Africa', iso2: 'ZA' },
  { name: 'South Korea', iso2: 'KR' },
  { name: 'Spain', iso2: 'ES' },
  { name: 'Sri Lanka', iso2: 'LK' },
  { name: 'St. Lucia', iso2: 'LC' },
  { name: 'St. Vincent and the Grenadines', iso2: 'VC' },
  { name: 'Sudan', iso2: 'SD' },
  { name: 'Suriname', iso2: 'SR' },
  { name: 'Sweden', iso2: 'SE' },
  { name: 'Switzerland', iso2: 'CH' },
  { name: 'Syrian Arab Republic', iso2: 'SY' },
  { name: 'Taiwan', iso2: 'TW' },
  { name: 'Tanzania', iso2: 'TZ' },
  { name: 'Thailand', iso2: 'TH' },
  { name: 'Togo', iso2: 'TG' },
  { name: 'Tonga', iso2: 'TO' },
  { name: 'Trinidad and Tobago', iso2: 'TT' },
  { name: 'Tunisia', iso2: 'TN' },
  { name: 'Turkey', iso2: 'TR' },
  { name: 'Turks and Caicos Islands', iso2: 'TC' },
  { name: 'Uganda', iso2: 'UG' },
  { name: 'Ukraine', iso2: 'UA' },
  { name: 'United Arab Emirates', iso2: 'AE' },
  { name: 'United Kingdom', iso2: 'GB' },
  { name: 'United States', iso2: 'US' },
  { name: 'Uruguay', iso2: 'UY' },
  { name: 'US Virgin Islands', iso2: 'VI' },
  { name: 'Uzbekistan', iso2: 'UZ' },
  { name: 'Vanuatu', iso2: 'VU' },
  { name: 'Venezuela', iso2: 'VE' },
  { name: 'Vietnam', iso2: 'VN' },
  { name: 'Yemen', iso2: 'YE' },
  { name: 'Zambia', iso2: 'ZM' },
  { name: 'Zimbabwe', iso2: 'ZW' },
] as const;
